import { DropDownList } from "@progress/kendo-react-dropdowns";
import "@progress/kendo-theme-default/dist/all.css";
import styled from "styled-components";
import { Heading } from "../../common.styles";
import "./dropdown.css";



// Dropdown categories  
const categories = [
    { id: null, label: "All types" },
    { id: "Full Time", label: "Full Time" },
    { id: "Part Time", label: "Part Time" },
    { id: "Contract", label: "Contract" },
];

const StyledHeading = styled(Heading)`
    color: #e1001e;
`;

export const TypeDropDownList = ({
    category,
    setCategory,
    jobsList
}) => {

    const categories = [
        { id: null, label: "All types" },
        ...jobsList.reduce((a,c) => {
            if (a.find(x=> x.id == c.type)) {
                return a
            } else {
                return [...a, {id: c.type, label: c.type}]
            }
        }, [])
    ];

    return (
        <section className="joinUs-filter-item">
            <form className="k-form">
                <StyledHeading>Type</StyledHeading>
                <DropDownList value={(category || categories[0]).label} data={categories.map((it) => { return it.label })} onChange={e => {
                    let selectedCategory = categories.filter((c) => {
                        return c.id != null
                            && c.label === e.value;
                    })
                    if (selectedCategory.length > 0) {
                        setCategory(selectedCategory[0]);
                    } else {
                        setCategory(null);
                    }
                }} />
            </form>
        </section>
    );
};